import { Component } from '@angular/core';

@Component({
  selector: 'shared-home-loader',
  templateUrl: './home-loader.component.html',
  styleUrls: ['./home-loader.component.scss'],
})
export class HomeLoaderComponent {
}
